/* marcel - produktove videa sa spustia, ked na ne clovek doscrolluje.
   Vyuziva Horizonov vlastny <deferred-media> a jeho loadContent(),
   ktora vlozi <video autoplay muted loop> z <template> a sama zavola play().
   Ziadny zasah do Shopify suborov -> tema zostava automaticky aktualizovatelna.

   POZOR na datovy objem: Shopify servuje jedinu kvalitu 1080p @ 4.8 Mbps.
   Preto:
     - nacitavame IBA prvok, ktory je naozaj videt (skryte kopie v galerii preskakujeme)
     - kazde unikatne video nacitame len raz
     - pri opusteni viewportu video pauzneme, aby nezralo baterku a data
*/
(() => {
  'use strict';

  const loadedSources = new Set();

  const sourceKeyOf = (dm) => {
    const tpl = dm.querySelector('template');
    const el = tpl?.content?.firstElementChild;
    const src = el?.querySelector?.('source')?.getAttribute('src') || el?.getAttribute?.('src') || '';
    return src.split('?')[0];
  };

  const isReallyVisible = (dm) => {
    const r = dm.getBoundingClientRect();
    return r.width > 40 && r.height > 40;
  };

  const enter = (dm) => {
    if (!isReallyVisible(dm)) return;

    const already = dm.dataset.mediaLoaded === 'true';

    if (!already) {
      const key = sourceKeyOf(dm);
      // to iste video sa v galerii vyskytuje viackrat - nacitaj ho len raz
      if (key && loadedSources.has(key)) return;
      if (key) loadedSources.add(key);

      if (typeof dm.loadContent === 'function') {
        dm.loadContent(false);
      } else {
        dm.querySelector('.deferred-media__poster-button, [ref="deferredMediaPlayButton"]')?.click();
      }
      return;
    }

    const v = dm.querySelector('video');
    if (v && v.paused) v.play().catch(() => {});
  };

  const leave = (dm) => {
    const v = dm.querySelector('video');
    if (v && !v.paused) v.pause();
  };

  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) enter(e.target);
        else leave(e.target);
      }
    },
    { rootMargin: '100px 0px 100px 0px', threshold: 0.25 }
  );

  const scan = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('deferred-media').forEach((dm) => {
      if (dm.dataset.marcelWatched) return;
      dm.dataset.marcelWatched = '1';
      io.observe(dm);
    });
  };

  const boot = () => {
    scan(document);
    new MutationObserver((muts) => {
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1) scan(n);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    // pri skryti zalozky pauzni vsetko
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) return;
      document.querySelectorAll('deferred-media video').forEach((v) => {
        if (!v.paused) v.pause();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
